export default function arrondiResult(value) {
  let newValue = value;
  if (newValue) {
    newValue = Math.round(newValue * 100) / 100;
  }
  return newValue;
}

export function isNaN(valeur) {
  return Number.isNaN(valeur) || typeof valeur !== 'number';
}

export function calculArrondi(valeur, arrondie = 2) {
  if (valeur === null || valeur === undefined || isNaN(valeur)) {
    return null;
  }
  const valeurArrondi = Math.round(Math.abs(valeur) * 10 ** arrondie) / 10 ** arrondie;
  if (valeur < 0 && valeurArrondi !== 0) {
    return -valeurArrondi;
  }
  return valeurArrondi;
}



// WEBPACK FOOTER //
// ./src/services/general/arrondiCalcul.js